import React from 'react'
import { useField } from 'formik'
import {
  Field,
  DateField as BubbleDateField,
  SwitchToggle,
  Dropdown,
  SwitchCheckbox,
  Radio
} from 'mage-deps/@klarna/bubble-ui'
import { string, arrayOf, object } from 'prop-types'
import { hooks as i18nHooks } from 'mage-i18n'
import TextArea from './TextArea'

const propTypes = {
  name: string.isRequired,
  label: string
}

FormikBubbleField.propTypes = propTypes
function FormikBubbleField({ name, label, ...props }) {
  const t = i18nHooks.useTranslator()
  const [field, meta, { setValue }] = useField(name)

  return (
    <Field
      {...field}
      {...props}
      label={label}
      errorLabel={meta.touched && meta.error ? t(meta.error) : undefined}
      onChange={setValue}
    />
  )
}

TextAreaField.propTypes = propTypes
function TextAreaField({ name, label, ...props }) {
  const t = i18nHooks.useTranslator()
  const [field, meta, { setValue, setTouched }] = useField(name)

  return (
    <TextArea
      {...field}
      {...props}
      testId={name}
      label={label}
      errorLabel={meta.touched && meta.error ? t(meta.error) : undefined}
      onChange={setValue}
      onBlur={() => setTouched(true)}
    />
  )
}

DateField.propTypes = propTypes
function DateField({ name, label, ...props }) {
  const t = i18nHooks.useTranslator()
  const [field, meta, { setValue }] = useField(name)

  return (
    <BubbleDateField
      {...field}
      {...props}
      placeholder="mm-dd-yyyy"
      label={label}
      separator="-"
      onChange={setValue}
      errorLabel={meta.touched && meta.error ? t(meta.error) : undefined}
    />
  )
}

CheckboxField.propTypes = propTypes
function CheckboxField({ name, label }) {
  const [field, meta, { setValue }] = useField(name)

  return (
    <SwitchCheckbox
      {...field}
      checked={field.value}
      rightAligned
      onChange={setValue}
      errorLabel={meta.error}
    >
      {label}
    </SwitchCheckbox>
  )
}

ToggleField.propTypes = propTypes
function ToggleField({ name, label }) {
  const [field, meta, { setValue }] = useField(name)

  return (
    <SwitchToggle
      {...field}
      checked={field.value}
      rightAligned
      onChange={setValue}
      errorLabel={meta.error}
    >
      {label}
    </SwitchToggle>
  )
}

SelectField.propTypes = { ...propTypes, options: arrayOf(object) }
function SelectField({ name, label, options, ...props }) {
  const t = i18nHooks.useTranslator()
  const [field, meta, { setValue }] = useField(name)

  const mergedOptions = [{ key: '', hidden: true }, ...options]

  return (
    <Dropdown
      data-testid={props['data-testid']}
      {...field}
      error={Boolean(meta.touched && meta.error)}
      label={(meta.touched && meta.error && t(meta.error)) || label}
      options={mergedOptions}
      onChange={setValue}
    />
  )
}

RadioField.propTypes = { ...propTypes, options: arrayOf(object) }
function RadioField({ name, label, options, ...props }) {
  const t = i18nHooks.useTranslator()
  const [field, meta, { setValue }] = useField(name)

  return (
    <Radio
      {...props}
      {...field}
      error={Boolean(meta.error)}
      label={(meta.touched && meta.error && t(meta.error)) || label}
      options={options}
      onChange={setValue}
    />
  )
}

export { DateField, ToggleField, SelectField, CheckboxField, RadioField, TextAreaField }

export default FormikBubbleField
